import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';
import { ROW_HEIGHT } from '../DataTable/DataTable.css';

export const paginatedTableFooterClass = style({
  marginTop: spacingVars.lg,
  height: ROW_HEIGHT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});
